import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import { c as clsx } from './clsx.m-7e9a4a81.js';

var _excluded = ["color", "weight", "italic", "children", "className"],
    _excluded2 = ["color", "weight", "italic", "children", "className", "preset"],
    _excluded3 = ["color", "weight", "italic", "children", "className", "preset"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }
// @ts-ignore

var HeadingCreator = function HeadingCreator(num) {
  var headingMainClassName = "smb-typo-h".concat(num);
  var htmlTagName = "h".concat(num);
  return function (props, ref) {
    var color = props.color,
        weight = props.weight,
        italic = props.italic,
        children = props.children,
        className = props.className,
        rest = _objectWithoutProperties(props, _excluded);

    var cls = clsx('smb-typoel', headingMainClassName, className, color && "smb-color-".concat(color), italic !== undefined && "smb-fst-".concat(italic ? 'italic' : 'normal'), weight && "smb-fw-".concat(weight));
    return /*#__PURE__*/React__default.createElement(htmlTagName, _objectSpread(_objectSpread({}, rest), {}, {
      className: cls,
      ref: ref
    }), children);
  };
};

var P = function P(props, ref) {
  var color = props.color,
      weight = props.weight,
      italic = props.italic,
      children = props.children,
      className = props.className,
      preset = props.preset,
      rest = _objectWithoutProperties(props, _excluded2);

  var cls = clsx('smb-typoel', preset && "smb-typo-".concat(preset), className, color && "smb-color-".concat(color), italic !== undefined && "smb-fst-".concat(italic ? 'italic' : 'normal'), weight && "smb-fw-".concat(weight));
  return /*#__PURE__*/React__default.createElement('p', _objectSpread(_objectSpread({}, rest), {}, {
    className: cls,
    ref: ref
  }), children);
};

var Text = function Text(props, ref) {
  var color = props.color,
      weight = props.weight,
      italic = props.italic,
      children = props.children,
      className = props.className,
      preset = props.preset,
      rest = _objectWithoutProperties(props, _excluded3);

  var cls = clsx('smb-typoel', preset && "smb-typo-".concat(preset), className, color && "smb-color-".concat(color), italic !== undefined && "smb-fst-".concat(italic ? 'italic' : 'normal'), weight && "smb-fw-".concat(weight));
  return /*#__PURE__*/React__default.createElement('span', _objectSpread(_objectSpread({}, rest), {}, {
    className: cls,
    ref: ref
  }), children);
};

var H1 = HeadingCreator(1);
var H2 = HeadingCreator(2);
var H3 = HeadingCreator(3);
var H4 = HeadingCreator(4);
var H5 = HeadingCreator(5);
var Typography = {
  H1: /*#__PURE__*/React__default.forwardRef(H1),
  H2: /*#__PURE__*/React__default.forwardRef(H2),
  H3: /*#__PURE__*/React__default.forwardRef(H3),
  H4: /*#__PURE__*/React__default.forwardRef(H4),
  H5: /*#__PURE__*/React__default.forwardRef(H5),
  P: /*#__PURE__*/React__default.forwardRef(P),
  Text: /*#__PURE__*/React__default.forwardRef(Text)
};

export { Typography as T };
